import React from 'react';
import { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { useSnackbar } from '../../../context/SnackbarContext';
import CompanySelect from '../controls/CompanySelect';
import OfficeSelect from '../controls/OfficeSelect';
import { useTranslation } from 'react-i18next';
import {Typography} from '@mui/material';
import { useAssignUserOffice } from '../../../hooks/useAssignUserOffice';

export default function UserOfficeForm({ user = null, company = null, office = null, mode = "create", open, onClose }) {

    const { t } = useTranslation('common'); 
    
    const [selectedCompany, setSelectedCompany] = useState(company ? company.id : "");
    const [selectedOffice, setSelectedOffice] = useState(office ? office.id : "");

    const { assign } = useAssignUserOffice();

    const { showSnackbar } = useSnackbar();

    React.useEffect(() => {
        setSelectedCompany(company ? company.id : "");
        setSelectedOffice(office ? office.id : "");
    }, [company, office, open]);

    const handleCompanyChange = (e) => {
        setSelectedOffice("");
        setSelectedCompany(e.target.value);
    };

    const handleSave = async () => {
        if (!selectedCompany) {
            showSnackbar(t('user_offices.messages.company_required'), "warning");
            return;
        }
        if (!selectedOffice) {
            showSnackbar(t('user_offices.messages.office_required'), "warning");
            return;
        }

        try {
            if (mode === "create") {
                await assign(user.id, selectedOffice);
                showSnackbar(t('user_offices.messages.assign_success'), "success");
            }
            setSelectedCompany("");   // clear field after save
            setSelectedOffice("");
            onClose();     // close dialog
            } catch (err) {
            showSnackbar(t('user_offices.messages.assign_fail'), "error");
        }

    };

    const handleCancel = () => {
        // clear field on cancel
        setSelectedCompany("");
        setSelectedOffice("");
        onClose();
    };

    return (
        <Dialog onClose={handleCancel} open={open} disableRestoreFocus>
        <DialogTitle>{mode === "create" ? "Add User to Office" : "Edit User Office"}</DialogTitle>

        <DialogContent dividers>
            <Stack spacing={1}>
                <Typography variant="h6">{user.name}</Typography>
                <Typography variant="body1">{user.email}</Typography>
                <CompanySelect
                    value={selectedCompany}
                    onChange={handleCompanyChange}
                />
                {selectedCompany && (
                    <OfficeSelect
                        companyId={selectedCompany}
                        value={selectedOffice}
                        onChange={(e) => setSelectedOffice(e.target.value)}
                    />
                )}
            </Stack>
        </DialogContent>

        <DialogActions>
            <Button 
            disabled={!selectedOffice}
            onClick={handleSave}
            >
                Save
            </Button>
            <Button onClick={handleCancel}>Cancel</Button>
        </DialogActions>
        </Dialog>
    );
}